import UserPage from './components/UserPage';

const routes = [
  {
    path: '/users',
    name: 'menu.user',
    icon: 'person',
    loginRequired: true,
    component: UserPage,
    weight: 900,
    permission: [],
    children: [],
  },
];

export default routes;
